import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment.test';

@Injectable()
export class ChatService {
  private resourceUrl = environment.API_URL + '/chats';

  constructor(private http: HttpClient) {}

  saveCurrent(params: any): Observable<any> {
    return this.http.post(this.resourceUrl + '/current', params, {
      observe: 'response',
    });
  }

  getCurrent(toId: number): Observable<any> {
    return this.http.get(this.resourceUrl + '/current/' + toId, {
      observe: 'response',
    });
  }
}
